/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountSettingRequest } from '../models/AccountSettingRequest';
import type { ApproverInput } from '../models/ApproverInput';
import type { EDocumentDto } from '../models/EDocumentDto';
import type { EmployeeInfoDto } from '../models/EmployeeInfoDto';
import type { HolidayAllowanceDto } from '../models/HolidayAllowanceDto';
import type { HolidayAllowanceInput } from '../models/HolidayAllowanceInput';
import type { InputConfirmState } from '../models/InputConfirmState';
import type { JobTitleInput } from '../models/JobTitleInput';
import type { JobTitleUpdateInput } from '../models/JobTitleUpdateInput';
import type { ManufacturerIdsInput } from '../models/ManufacturerIdsInput';
import type { PermissionSectionDto } from '../models/PermissionSectionDto';
import type { PersonalDetailsDto } from '../models/PersonalDetailsDto';
import type { PersonalDetailsHistoryDto } from '../models/PersonalDetailsHistoryDto';
import type { PersonalDetailsHistoryShortDto } from '../models/PersonalDetailsHistoryShortDto';
import type { PersonalDetailsInput } from '../models/PersonalDetailsInput';
import type { RequestDocumentCategoryInput } from '../models/RequestDocumentCategoryInput';
import type { RequestDocumentInput } from '../models/RequestDocumentInput';
import type { RequestPhotoInput } from '../models/RequestPhotoInput';
import type { SalaryHistoryDto } from '../models/SalaryHistoryDto';
import type { SalaryHistoryInput } from '../models/SalaryHistoryInput';
import type { SendUserReqeustDocumentCategoryInput } from '../models/SendUserReqeustDocumentCategoryInput';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { TechnicianEfficiencyReportDto } from '../models/TechnicianEfficiencyReportDto';
import type { TemplatesToSignDto } from '../models/TemplatesToSignDto';
import type { UpdatePasswordInput } from '../models/UpdatePasswordInput';
import type { UserAccessSettingsDto } from '../models/UserAccessSettingsDto';
import type { UserCandidatesDto } from '../models/UserCandidatesDto';
import type { UserCandidatesDtoPagedListData } from '../models/UserCandidatesDtoPagedListData';
import type { UserCandidatesGeneratePdfDocumentsDto } from '../models/UserCandidatesGeneratePdfDocumentsDto';
import type { UserCandidatesInput } from '../models/UserCandidatesInput';
import type { UserCandidatesSingDocumentsDto } from '../models/UserCandidatesSingDocumentsDto';
import type { UserCompanyCarDto } from '../models/UserCompanyCarDto';
import type { UserContractChangesSendEmailInput } from '../models/UserContractChangesSendEmailInput';
import type { UserInfo } from '../models/UserInfo';
import type { UserManufacturerIdsInfo } from '../models/UserManufacturerIdsInfo';
import type { UserOvertimeRangeHistoryDto } from '../models/UserOvertimeRangeHistoryDto';
import type { UserOvertimeRangeInput } from '../models/UserOvertimeRangeInput';
import type { UserPersonalFileDto } from '../models/UserPersonalFileDto';
import type { UserReqeustDto } from '../models/UserReqeustDto';
import type { UserRequestDocumentDto } from '../models/UserRequestDocumentDto';
import type { UserResultDto } from '../models/UserResultDto';
import type { UserRole } from '../models/UserRole';
import type { UserStatus } from '../models/UserStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { HolidayAllowaceCalcDto } from '../models/HolidayAllowaceCalcDto';

export class UserService {

  /**
   * @param employeeName 
   * @param branch 
   * @param date 
   * @returns TechnicianEfficiencyReportDto Success
   * @throws ApiError
   */
  public static getUsersGetTechnicianEfficiencyReport(
employeeName?: string,
branch?: number,
date?: string,
): CancelablePromise<Array<TechnicianEfficiencyReportDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/get-technician-efficiency-report',
      query: {
        'employeeName': employeeName,
        'branch': branch,
        'date': date,
      },
    });
  }

  /**
   * @param branch 
   * @param date 
   * @returns any Success
   * @throws ApiError
   */
  public static getUsersSaveCommission(
branch?: number,
date?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/save-commission',
      query: {
        'branch': branch,
        'date': date,
      },
    });
  }

  /**
   * @param id 
   * @param date 
   * @returns TechnicianEfficiencyReportDto Success
   * @throws ApiError
   */
  public static getUsersGetTechnicianEfficiencyReportUser(
id: number,
date?: string,
): CancelablePromise<TechnicianEfficiencyReportDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/get-technician-efficiency-report-user/{id}',
      path: {
        'id': id,
      },
      query: {
        'date': date,
      },
    });
  }

  /**
   * @param userId 
   * @returns UserAccessSettingsDto Success
   * @throws ApiError
   */
  public static getUsersAccessSettings(
userId: number,
): CancelablePromise<UserAccessSettingsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{userId}/access-settings',
      path: {
        'userId': userId,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static postUsersAccessSettings(
userId: number,
requestBody?: AccountSettingRequest,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{userId}/access-settings',
      path: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
      },
    });
  }

  /**
   * @param role 
   * @param branchId 
   * @param departmentId 
   * @param status 
   * @param furlough 
   * @param isEmployee 
   * @param name 
   * @param canBeApprover 
   * @param minEmploymentEndDateInclude 
   * @param jobTitle 
   * @param hasPermissionDriveCompanyCar 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns UserResultDto Success
   * @throws ApiError
   */
  public static getUsers(
role?: Array<UserRole>,
branchId?: number,
departmentId?: number,
status?: Array<UserStatus>,
furlough?: boolean,
isEmployee?: boolean,
name?: string,
canBeApprover?: boolean,
minEmploymentEndDateInclude?: string,
jobTitle?: number,
hasPermissionDriveCompanyCar?: boolean,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<UserResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users',
      query: {
        'Role': role,
        'BranchId': branchId,
        'DepartmentId': departmentId,
        'Status': status,
        'Furlough': furlough,
        'IsEmployee': isEmployee,
        'Name': name,
        'CanBeApprover': canBeApprover,
        'MinEmploymentEndDateInclude': minEmploymentEndDateInclude,
        'JobTitle': jobTitle,
        'HasPermissionDriveCompanyCar': hasPermissionDriveCompanyCar,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param formData 
   * @returns UserInfo Success
   * @throws ApiError
   */
  public static postUsers(
formData?: {
Login: string;
Password: string;
Name: string;
BranchId: number;
JobTitle: number;
Email: string;
Phone?: string;
Role: UserRole;
DepartmentId?: number;
IsEmployee?: boolean;
PayrollCode?: string;
Photo?: Blob;
StartingDate?: string;
AdvisorId?: string;
},
): CancelablePromise<UserInfo> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param role 
   * @param branchId 
   * @param departmentId 
   * @param status 
   * @param furlough 
   * @param isEmployee 
   * @param name 
   * @param canBeApprover 
   * @param minEmploymentEndDateInclude 
   * @param jobTitle 
   * @param hasPermissionDriveCompanyCar 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns any Success
   * @throws ApiError
   */
  public static getUsersExport(
role?: Array<UserRole>,
branchId?: number,
departmentId?: number,
status?: Array<UserStatus>,
furlough?: boolean,
isEmployee?: boolean,
name?: string,
canBeApprover?: boolean,
minEmploymentEndDateInclude?: string,
jobTitle?: number,
hasPermissionDriveCompanyCar?: boolean,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/export',
      query: {
        'Role': role,
        'BranchId': branchId,
        'DepartmentId': departmentId,
        'Status': status,
        'Furlough': furlough,
        'IsEmployee': isEmployee,
        'Name': name,
        'CanBeApprover': canBeApprover,
        'MinEmploymentEndDateInclude': minEmploymentEndDateInclude,
        'JobTitle': jobTitle,
        'HasPermissionDriveCompanyCar': hasPermissionDriveCompanyCar,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getUsersJobTitles(): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/job-titles',
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersJobTitles(
requestBody?: Array<JobTitleInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/job-titles',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersJobTitles(
requestBody?: Array<JobTitleUpdateInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/job-titles',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersJobTitles(
requestBody?: Array<number>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/job-titles',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersJobTitles1(
id: number,
requestBody?: JobTitleInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/job-titles/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns UserInfo Success
   * @throws ApiError
   */
  public static getUsers1(
id: number,
): CancelablePromise<UserInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsers(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersBlock(
id: number,
formData?: {
isUnblock?: boolean;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/block',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static getUsersReturn(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/return',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns EmployeeInfoDto Success
   * @throws ApiError
   */
  public static getUsersEmployeeInfo(
id: number,
): CancelablePromise<EmployeeInfoDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/EmployeeInfo',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersEmployeeInfo(
id: number,
formData?: {
Uid: string;
Name: string;
BranchId: number;
JobTitle: number;
Email: string;
Phone?: string;
Role: UserRole;
DepartmentId?: number;
PayrollCode?: string;
StartingDate?: string;
PayrollN?: string;
HolidayAllowance?: number;
CanBeApprover?: boolean;
WorkInHoliday?: boolean;
WorkingTimeNorm?: number;
IsEmployee?: boolean;
ImageFile?: Blob;
EmploymentEndDate?: string;
SalaryHourlyRate?: number;
SalaryAnnual?: number;
NotificationPriority?: number;
DateStart?: string;
AdvisorId?: string;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/EmployeeInfo',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersEmployeeInfoPhoto(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}/EmployeeInfo/Photo',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns PersonalDetailsDto Success
   * @throws ApiError
   */
  public static getUsersPersonalDetails(
id: number,
): CancelablePromise<PersonalDetailsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/PersonalDetails',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersPersonalDetails(
id: number,
requestBody?: PersonalDetailsInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/PersonalDetails',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns PersonalDetailsHistoryDto Success
   * @throws ApiError
   */
  public static getUsersPersonalHistoryDetails(
id: number,
): CancelablePromise<PersonalDetailsHistoryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/PersonalHistoryDetails/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param take 
   * @returns PersonalDetailsHistoryShortDto Success
   * @throws ApiError
   */
  public static getUsersPersonalHistoryShortDetails(
id: number,
take: number,
): CancelablePromise<Array<PersonalDetailsHistoryShortDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/PersonalHistoryShortDetails/{id}/{take}',
      path: {
        'id': id,
        'take': take,
      },
    });
  }

  /**
   * @param uid 
   * @returns PersonalDetailsDto Success
   * @throws ApiError
   */
  public static getUsersPersonalDetails1(
uid?: string,
): CancelablePromise<PersonalDetailsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/PersonalDetails',
      query: {
        'uid': uid,
      },
    });
  }

  /**
   * @param uid 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersPersonalDetails1(
uid?: string,
requestBody?: PersonalDetailsInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/PersonalDetails',
      query: {
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersPersonalDetailsUpdateDateSentToFill(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/PersonalDetails/update-date-sent-to-fill',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postUsersRequestPhoto(
id: number,
requestBody?: RequestPhotoInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/request-photo',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param uid 
   * @returns boolean Success
   * @throws ApiError
   */
  public static getUsersRequestPhotoStatus(
uid?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/request-photo-status',
      query: {
        'uid': uid,
      },
    });
  }

  /**
   * @param uid 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersPhoto(
uid?: string,
formData?: {
Photo: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/Photo',
      query: {
        'uid': uid,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersPersonalDetailsConfirmState(
id: number,
requestBody?: InputConfirmState,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/personal-details/confirm-state',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns UserPersonalFileDto Success
   * @throws ApiError
   */
  public static getUsersPersonalFiles(
id: number,
): CancelablePromise<Array<UserPersonalFileDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/personal-files',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersPersonalFiles(
id: number,
formData?: {
Description?: string;
PersonalFile: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/personal-files',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param personalFileId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersPersonalFiles(
id: number,
personalFileId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}/personal-files/{personalFileId}',
      path: {
        'id': id,
        'personalFileId': personalFileId,
      },
    });
  }

  /**
   * @param id 
   * @returns UserReqeustDto Success
   * @throws ApiError
   */
  public static getUsersRequestDocumentCategories(
id: number,
): CancelablePromise<UserReqeustDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/request-document-categories',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param uid 
   * @returns UserReqeustDto Success
   * @throws ApiError
   */
  public static getUsersRequestDocumentCategories1(
uid?: string,
): CancelablePromise<UserReqeustDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/request-document-categories',
      query: {
        'uid': uid,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersRequestDocumentCategories(
requestBody?: RequestDocumentCategoryInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/request-document-categories',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param categoryId 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersRequestDocumentCategories1(
id: number,
categoryId: number,
requestBody?: SendUserReqeustDocumentCategoryInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/request-document-categories/{categoryId}',
      path: {
        'id': id,
        'categoryId': categoryId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param submited 
   * @returns UserRequestDocumentDto Success
   * @throws ApiError
   */
  public static getUsersRequestDocuments(
id: number,
submited?: boolean,
): CancelablePromise<Array<UserRequestDocumentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/request-documents',
      path: {
        'id': id,
      },
      query: {
        'submited': submited,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersRequestDocuments(
id: number,
requestBody?: Array<RequestDocumentInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/request-documents',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param uid 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersRequestDocuments1(
uid?: string,
requestBody?: Array<RequestDocumentInput>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/request-documents',
      query: {
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestDocumentId 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersRequestDocumentsAccept(
id: number,
requestDocumentId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/request-documents/{requestDocumentId}/accept',
      path: {
        'id': id,
        'requestDocumentId': requestDocumentId,
      },
    });
  }

  /**
   * @param id 
   * @param requestDocumentId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersRequestDocumentsDecline(
id: number,
requestDocumentId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}/request-documents/{requestDocumentId}/decline',
      path: {
        'id': id,
        'requestDocumentId': requestDocumentId,
      },
    });
  }

    /**
   * @param documentId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersEDocument(
documentId : number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/e-documents/{documentId}',
      path: {
        'documentId': documentId,
      },
    });
  }

  /**
   * @param id 
   * @returns EDocumentDto Success
   * @throws ApiError
   */
  public static getUsersEDocuments(
id: number,
): CancelablePromise<EDocumentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/e-documents',
      path: {
        'id': id,
      },
    });
  }

    /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
    public static postUsersEDocumentsAmendmentToEmployee(
      id: number,
      ): CancelablePromise<EDocumentDto> {
          return __request(OpenAPI, {
            method: 'POST',
            url: '/users/{id}/e-documents/amendment-to-employee',
            path: {
              'id': id,
            },
          });
        }

  /**
   * @param fileUid 
   * @param fileName 
   * @returns any Success
   * @throws ApiError
   */
  public static getUsersDownloadFileFileName(
fileUid: string,
fileName: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/download-file/{fileUid}/file-name/{fileName}',
      path: {
        'fileUid': fileUid,
        'fileName': fileName,
      },
    });
  }

  /**
   * @returns TemplatesToSignDto Success
   * @throws ApiError
   */
  public static getUsersSignTemplates(): CancelablePromise<Array<TemplatesToSignDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/sign-templates',
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersSendSignTemplates(
id: number,
formData?: {
Description: string;
Name: string;
File: Blob;
CountSignatories: number;

},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/send-sign-templates',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param templateId 
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersSendSignTemplates1(
id: number,
templateId: number,
formData?: {
description: string;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/send-sign-templates/{templateId}',
      path: {
        'id': id,
        'templateId': templateId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersSendSignOne(
id: number,
formData?: {
Description: string;
File: Blob;
CountSignatories: number;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/send-sign-one',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param id 
   * @returns UserCompanyCarDto Success
   * @throws ApiError
   */
  public static getUsersCompanyCars(
id: number,
): CancelablePromise<UserCompanyCarDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/company-cars',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postUsersApprover(
id: number,
requestBody?: ApproverInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/approver',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param year 
   * @returns HolidayAllowaceCalcDto Success
   * @throws ApiError
   */
  public static getUsersRemainingDays(
id: number,
year: number,
): CancelablePromise<HolidayAllowaceCalcDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/remaining-days/{year}',
      path: {
        'id': id,
        'year': year,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getUsersDepartments(): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/departments',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postUsersPassword(
id: number,
requestBody?: UpdatePasswordInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/password',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns HolidayAllowanceDto Success
   * @throws ApiError
   */
  public static getUsersHolidayAllowance(
id: number,
): CancelablePromise<Array<HolidayAllowanceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/holiday-allowance',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postUsersHolidayAllowance(
id: number,
requestBody?: HolidayAllowanceInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/holiday-allowance',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param holidayAllowanceId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersHolidayAllowance(
id: number,
holidayAllowanceId: number,
requestBody?: HolidayAllowanceInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}/holiday-allowance/{holidayAllowanceId}',
      path: {
        'id': id,
        'holidayAllowanceId': holidayAllowanceId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param holidayAllowanceId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersHolidayAllowance(
id: number,
holidayAllowanceId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}/holiday-allowance/{holidayAllowanceId}',
      path: {
        'id': id,
        'holidayAllowanceId': holidayAllowanceId,
      },
    });
  }

  /**
   * @param role
 *
 * 0 = DefaultEmployee (Роль по умолчанию, минимум возможностей)
 *
 * 1 = Administrator (Имеет доступ ко всем страницам и всему функционалу)
 *
 * 2 = Accountant (Бухгалтер)
 *
 * 3 = BdcAdvisor
 *
 * 4 = BodyshopManager
 *
 * 5 = PartsDriver
 *
 * 6 = PartsManager
 *
 * 7 = SalesAdministrator
 *
 * 8 = SalesConsultant (Анжела его еще называет Sales Exec)
 *
 * 9 = SalesManager
 *
 * 10 = ServiceAdvisor
 *
 * 11 = ServiceDriver
 *
 * 12 = ServiceManager
 *
 * 13 = SiteCoordinator
 *
 * 14 = Valetor
 *
 * 15 = Technician
 *
 * 16 = CarBuyer
 *
 * 17 = BodyshopOperative
 *
 * 18 = Marketing
 *
 * 19 = Maintenance
   * @returns PermissionSectionDto Success
   * @throws ApiError
   */
  public static getUsersPermissions(
role?: UserRole,
): CancelablePromise<Array<PermissionSectionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/permissions',
      query: {
        'role': role,
      },
    });
  }

  /**
   * @param id 
   * @returns UserManufacturerIdsInfo Success
   * @throws ApiError
   */
  public static getUsersManufacturerIds(
id: number,
): CancelablePromise<Array<UserManufacturerIdsInfo>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}/manufacturer-ids',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postUsersManufacturerIds(
id: number,
requestBody?: ManufacturerIdsInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{id}/manufacturer-ids',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param userId 
   * @returns UserOvertimeRangeHistoryDto Success
   * @throws ApiError
   */
  public static getUsersUserOvertimeRangeHistories(
userId: number,
): CancelablePromise<Array<UserOvertimeRangeHistoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{userId}/user-overtime-range-histories',
      path: {
        'userId': userId,
      },
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postUsersUserOvertimeRangeHistory(
userId: number,
requestBody?: UserOvertimeRangeInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{userId}/user-overtime-range-history',
      path: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param userId 
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersUserOvertimeRangeHistory(
userId: number,
id: number,
requestBody?: UserOvertimeRangeInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{userId}/user-overtime-range-history/{id}',
      path: {
        'userId': userId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersUserOvertimeRangeHistory(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/user-overtime-range-history/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param userId 
   * @param formData 
   * @returns SalaryHistoryDto Success
   * @throws ApiError
   */
  public static getUsersSalaryHistories(
userId: number,
formData?: {
SalaryType?: number;
},
): CancelablePromise<Array<SalaryHistoryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/{userId}/salary-histories',
      path: {
        'userId': userId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param userId 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersSalaryHistory(
userId: number,
requestBody?: SalaryHistoryInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/{userId}/salary-history',
      path: {
        'userId': userId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param userId 
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersSalaryHistory(
userId: number,
id: number,
requestBody?: SalaryHistoryInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{userId}/salary-history/{id}',
      path: {
        'userId': userId,
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersSalaryHistory(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/salary-history/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postUsersUserCandidates(
requestBody?: UserCandidatesInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/user-candidates',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param name 
   * @param branchId 
   * @param jobTitle 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns UserCandidatesDtoPagedListData Success
   * @throws ApiError
   */
  public static getUsersUserCandidates(
name?: string,
branchId?: number,
jobTitle?: string,
sort?: string,
order?: SortTypeEnum,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<UserCandidatesDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/user-candidates',
      query: {
        'Name': name,
        'BranchId': branchId,
        'JobTitle': jobTitle,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersUserCandidates(
id: number,
requestBody?: UserCandidatesInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/user-candidates/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns UserCandidatesDto Success
   * @throws ApiError
   */
  public static getUsersUserCandidates1(
id: number,
): CancelablePromise<UserCandidatesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/user-candidates/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersUserCandidates(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/user-candidates/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns any Success
   * @throws ApiError
   */
  public static putUsersUserCandidatesAttachToUser(
id: number,
userId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/users/user-candidates/{id}/attach-to-user/{userId}',
      path: {
        'id': id,
        'userId': userId,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postUsersUserCandidatesSendEmail(
id: number,
requestBody?: UserContractChangesSendEmailInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/user-candidates/{id}/send-email',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @returns UserCandidatesSingDocumentsDto Success
   * @throws ApiError
   */
  public static getUsersUserCandidatesSingDocuments(
id: number,
): CancelablePromise<Array<UserCandidatesSingDocumentsDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/user-candidates/{id}/sing-documents',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns UserCandidatesGeneratePdfDocumentsDto Success
   * @throws ApiError
   */
  public static postUsersUserCandidatesPdfDocuments(
id: number,
): CancelablePromise<UserCandidatesGeneratePdfDocumentsDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/users/user-candidates/{id}/pdf-documents',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteUsersUserCandidatesPdfDocuments(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/user-candidates/{id}/pdf-documents',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param role 
   * @param branchId 
   * @param departmentId 
   * @param status 
   * @param isEmployee 
   * @returns any Success
   * @throws ApiError
   */
  public static getUsersReport(
role?: Array<UserRole>,
branchId?: number,
departmentId?: number,
status?: Array<UserStatus>,
isEmployee?: boolean,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/report',
      query: {
        'Role': role,
        'BranchId': branchId,
        'DepartmentId': departmentId,
        'Status': status,
        'IsEmployee': isEmployee,
      },
    });
  }

}
